<template>
	<div v-if="show" class="wid100">
		<div v-if="datalist.length" class="drawerpage">

			<div class="contacts_tit Flexalcent">
				相关回款
			</div>

			<div class="contacts_cotnent">
				<!--  -->
				<div class="contacts_item Flexalcent" v-for="(item,index) in datalist">
					<!--  -->
					
					<div class="lefte">
						<div class="gl_name">
							回款编号：{{item.hk_code || ''}}
						</div>
						
						<div class="sj_qyname" v-if="item.customer_name">
							<div class="txt FlexRow">
								<img :src="urlhead + '/renz1.png'">
								{{item.customer_name || ''}}
							</div>
						</div>
						<div class="sj_qyname" v-else-if="item.customer.name1">
						
							<div class="txt FlexRow">
								<img :src="urlhead + '/renz1.png'">
								{{item.customer.name1 || ''}}
							</div>
						</div>
						
						<div class="sj_state">
							<div class="state state3" v-if="item.return_nature == 1">
								收款
							</div>
							<div class="state state3" v-else>
								预收款
							</div>
							
							<div class="state state3" v-if="item.audit_status == 0">
								待审核
							</div>
							<div class="state state1" v-else-if="item.audit_status == 1">
								已确认
							</div>
							<div class="state state2" v-else>
								拒绝
							</div>
						</div>
						
					</div>
					
					<div class="rlines"></div>
					<!--  -->
					<div class="righte">
						
						<div class="te_line Flexalcent">
							<div class="te_sopa ">
								负责人：{{item.member_name || item.member.name || ''}}
							</div>
							<div class="te_sopa Flexalcent">
								合同金额：
								<span v-if="item.amount" >
									￥{{item.amount || 0}}
								</span>
							</div>
						</div>
						<div class="te_line Flexalcent">
							<div class="te_sopa Flexalcent">
								回款日期：
								<span v-if="item.return_time">
									{{item.return_time || ''}}
								</span>
							</div>
							<div class="te_sopa Flexalcent">
								回款金额：
								<span v-if="item.huikuan" style="color: rgba(255, 125, 0, 1);">
									￥{{item.huikuan || 0}}
								</span>
							</div>
						</div>
						
						<div class="te_line Flexalcent">
							<div class="te_sopa Flexalcent">
								合同源单：
								<span v-if="item.contract_name" >
									{{item.contract_name || ''}}
								</span>
							</div>
						</div>
						
						
						
						
					</div>
					<!--  -->
				
				
				</div>
				<!--  -->
				
			</div>
			<!--  -->
		</div>
		
		<!-- 没有数据 -->
		<template v-else>
			<nodata :show="true"></nodata>
		</template>
		<!--  -->
	</div>

</template>

<script>
	var that
	import {


		gchance_list,

		hkl_list_return,
		xmde_list,
		get_contracTlist,

		xmde_del,
		
		lx_typelist,

		del_business_chance,
		hkl_del_return,
	} from 'network/hk_operset'


	import nodata from "@/components/content/publics/nodata.vue";
	export default {
		components: {
			nodata,
		},
		name: "relacusreturn",
		props: {

			show: {
				type: Boolean,
				default: false,
			},
			
			list: {
				type: Array,
				default: [],
			},
			
			chance_id: {
				type: Number,
				default: 0,
			},
			
			contract_id: {
				type: Number,
				default: 0,
			},
			customer_id: {
				type: Number,
				default: 0,
			},


		},
		data() {
			return {
				//

				urlhead: 'https://scrm.51kuaiding.com/scrm/hktxcx/customer',
				datalist: [],
				
			

			}
		},

		created() {
			that = this


		},
		watch: {
			show() {
				if (this.show) {
					if (this.list.length) {
						this.datalist = this.list
					} else {
						this.getlists()
					}
					
				} else {
					this.datalist = []
				}
				
			},
		},

		methods: {
			
			

			getlists() {
				let data = {
					pagesize: 999,
					sort_type: 1,
				
				} 
				if(this.contract_id) {
					data.contract_id = this.contract_id
				}
				if(this.customer_id) {
					data.customer_id = this.customer_id
				}
				hkl_list_return(data).then(res => {
					if (this.handlereq(res)) {
						let obj = res.result.data
						this.handle_data(obj)
						if(obj.length){
							this.$emit('retunm', {num: obj.length})
						}
					}
				})
			},
			handle_data(data) {
				if (data) {
					for (let item of data) {
						if (item.return_time) {
							item.return_time = item.return_time.slice(0, 10)
						}
						if (item.return_info && typeof(item.return_info) == 'string') {
							let newArr = JSON.parse(item.return_info)
							if (newArr.length > 0) {
								let index = newArr.findIndex(v => v.field_sign == '合同金额')
								if (index != -1) {
									item.amount = newArr[index].content;
								}
								let index2 = newArr.findIndex(v => v.field_sign == '回款金额')
								if (index2 != -1) {
									item.huikuan = newArr[index2].content || 0;
								}
							}
						}
					}
					this.$nextTick(() => {
						this.datalist = data
						console.log(this.datalist, 'datalist')
					})

				}
			},







			// 弹出提示
			alertMess(message, type) {
				this.$message({
					showClose: true,
					offset: 100,
					duration: 2000,
					message,
					type: type ? type : 'success',
				});
			},
			handlereq(res) {
				if (res) {
					if (res.code === 10000) { // 请求成功
						return true
					} else { // 请求发生错误
						this.alertMess(res.message, 'error')
						return false
					}
				}
			},




		}
	}
</script>

<style scoped lang="scss">
	
	.Flexalcent {
		display: flex;
		align-items: center;
	}

	.contacts_tit {
		font-size: 16px;
		position: relative;
		color: rgba(56, 56, 56, 1);
		margin-bottom: 24px;
	}

	.contacts_tit::before {
		content: '';
		display: block;
		width: 3px;
		height: 20px;
		margin-right: 9px;
		background: rgba(43, 117, 235, 1);
	}

	.contacts_cotnent {
		width: 100%;

		.contacts_item {
			margin-bottom: 14px;
			width: 100%;
			max-width: 734px;
			min-height: 113px;
			border-radius: 5px;
			background: rgba(255, 255, 255, 1);
			padding: 19px;
			border-right: solid 1px rgba(240, 240, 240, 1);
			.rlines{
				width: 1px;
				height: 66px;
				background-color: rgba(240, 240, 240, 1);
			}
			.lefte {
				width: 280px;
				// border-right: solid 1px rgba(240, 240, 240, 1);
				.gl_name {
					font-size: 18px;
					font-weight: 550;
					color: rgba(56, 56, 56, 1);
					margin-bottom: 10px;
				}

				.sj_qyname {
					margin-bottom: 10px;
					display: flex;
					align-items: center;
					.txt {
						font-size: 12px;
						color: rgba(150, 150, 150, 1);
				
						img {
							width: 15px;
							height: 15px;
							display: block;
							margin-right: 6px;
						}
					}
				}
				
				.sj_state {
					margin-bottom: 10px;
					display: flex;
					align-items: center;
				
					.state {
						height: 20px;
						padding: 0 10px;
						border-radius: 3px;
						font-size: 12px;
						margin-right: 7px;
						display:flex;
						align-items: center;
						justify-content: center;
					}
				
					.state1 {
						color: rgba(82, 196, 26, 1);
						background: rgba(235, 255, 236, 1);
					}
				 
					.state2 {
						color: rgba(255, 125, 0, 1);
						background: rgba(249, 237, 217, 1);
					}
				
					.state3 {
						color: rgba(43, 117, 235, 1);
						background: rgba(235, 241, 255, 1);
					}
				}
				
			
			}

			.righte {
				padding-left: 50px;
				flex: 1;
				padding-right: 10px;
				.te_line{
					margin-bottom: 8px;
					.te_sopa{
						flex: 1;
						font-size: 13px;
						color: rgba(150, 150, 150, 1);
						
					}
				}
			}
		}
	}


</style>
